import { Property } from '@app/shared/interfaces';

export interface DynamicPricingPreview {
  [date: string]: {
    price: DynamicPricingSuggestion;
  };
}

export interface DynamicPricingSuggestion {
  currency: string;
  amount: number;
  display: string;
  base_amount: number;
  base_display: string;
  attribution: {
    time: AmountWithDisplay;
    source: AmountWithDisplay;
    seasonality: AmountWithDisplay;
    availability: AmountWithDisplay;
    local_demand: AmountWithDisplay;
    custom_weekend: AmountWithDisplay;
    user_adjustment: AmountWithDisplay;
    occupancy_pacing: AmountWithDisplay;
    historical_anchoring: AmountWithDisplay;
  };
}

interface AmountWithDisplay {
  amount: number;
  display: string;
}

export interface DynamicPricingOptionsPayload {
  dynamic_pricing_enabled: boolean; // Get more prices than just the 30 day preview
  outbound_dynamic_pricing_enabled?: boolean; // send the prices to the OTA
  base_price_type: PricingPreference;
  base_price: number;
  min_price: number;
  max_price: number;
  override_manual_edits?: boolean;
}

export type DynamicPricingOptionsResponse = Omit<DynamicPricingOptionsPayload, 'min_price' | 'max_price' | 'base_price'> & {
  current_base_price_type?: PricingPreference;
  base_price?: AmountWithDisplay;
  min_price: AmountWithDisplay;
  max_price: AmountWithDisplay;
  base_prices: { [key in BasePriceTypes]: AmountWithDisplay };
  data_errors?: Record<string, any>;
  in_market?: boolean;
};

export enum PricingPreference {
  CONSERVATIVE = 'conservative',
  RECOMMENDED = 'recommended',
  AGGRESSIVE = 'aggressive',
  CUSTOM = 'custom',
}
export type BasePriceTypes = PricingPreference | 'custom';

export interface DialogData {
  property: Property;
  dynamic_pricing_enabled: DynamicPricingOptionsPayload['dynamic_pricing_enabled'];
  base_price_type: DynamicPricingOptionsPayload['base_price_type'];
  base_price: DynamicPricingOptionsPayload['base_price'];
  min_price: DynamicPricingOptionsPayload['min_price'];
  max_price: DynamicPricingOptionsPayload['max_price'];
  manualPricedDaysPercentage: number;
  mode: 'setup' | 'update';
}

export const DYNAMIC_PRICING_PERIOD = 24;

export const DYNAMIC_PRICING_PREVIEW_ATTRIBUTION_MAP = {
  availability: 'Availability',
  custom_weekend: 'Weekend prices',
  historical_anchoring: 'Past pricing',
  local_demand: 'Local demand',
  occupancy_pacing: 'Occupancy trends',
  restriction: 'Restrictions',
  scarcity: 'Scarcity',
  seasonality: 'Seasonality',
  time: 'Booking window',
  user_adjustment: 'Personal adjustment',
  hospitable_price: 'Dynamic price',
};
